import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Divider,
} from "@mui/material";
import { convertDateToWords } from "../utils/dateToWords";

export default function TwoPageMarksheetReceipt({ receiptData, school, setTemID }) {
  const activities = [
    { name: "Formative Assessment-I" },
    { name: "Formative Assessment-II" },
    { name: "Final-Exam" },
  ];
  //marksheet 5/17
  const totalGrade = [
    { name: "Semester" },
    { name: "Education" },
    { name: "Co-Curricular" },
    { name: "Total" },
    { name: "Special Remark" },
    { name: "C. Teacher Signature" },
  ];

  const totalActivity = [
    { name: "Qualities" },
    { name: "Creativity" },
    { name: "Regularity" },
    { name: "Punctuality" },
    { name: "Cleanness" },
    { name: "Cultural" },
    { name: "Discipline" },
    { name: "Confidence" },
    { name: "School Program" },
    { name: "School Mates " },
  ];

  const student = receiptData.data;//markData[0]?.classRoom[0];

  const receiptId = `marksheet`;

  useEffect(() => {
    if (setTemID) {
      setTemID(receiptId);
    }
  }, [receiptData, setTemID, receiptId]);

  // extract unique subjects
  const subjects = useMemo(() => {
    const allMarks = student.flatMap((ms) => ms.marks);
    const unique = [...new Map(allMarks.map((m) => [m.subjectName.trim(), m])).values()];
    return unique.sort((a, b) =>
      a.subjectName.toLowerCase().localeCompare(b.subjectName.toLowerCase())
    );
  }, [student]);

  // quick lookup
  const findMark = (examType, subject) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    return term?.marks.find(
      (s) => s.subjectName.trim().toLowerCase() === subject.trim().toLowerCase()
    );
  };

  const getTotals = (examType, rem) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    if (!term) return { max: 0, obt: 0, grade: "-" };
    const max = term.marks.filter(s => s.remark !== rem).reduce((sum, s) => sum + (s.maxMark || 0), 0);
    const obt = term.marks.filter(s => s.remark !== rem).reduce((sum, s) => sum + (s.marksObtained || 0), 0);
    return { max, obt, grade: term.grade };
  };

  const getTotalsNoon = (examType, rem) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    if (!term) return { max: 0, obt: 0, grade: "-" };
    const max = term.marks.filter(s => s.remark === rem).reduce((sum, s) => sum + (s.maxMark || 0), 0);
    const obt = term.marks.filter(s => s.remark === rem).reduce((sum, s) => sum + (s.marksObtained || 0), 0);
    return { max, obt, grade: term.grade };
  };

  const [terms, setTerms] = useState([
    { n: "First" },
    { n: "Second" },
    { n: "Final" }
  ]);

  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };

  const t1 = getTotals("First", "non");
  const t2 = getTotals("Second", "non");
  const t3 = getTotals("Final", "non");

  const t4 = getTotalsNoon("First", "non");
  const t5 = getTotalsNoon("Second", "non");
  const t6 = getTotalsNoon("Final", "non");

  const cell = { border: "1px double #000", padding: "6px" };
  const cell1 = { border: "1px double #000", padding: "0px 2px" };

  const MarksRow = (term) =>
    term?.remark !== "non" && (
      <>
        <TableCell sx={cell} align="center">{term?.maxMark ?? 100}</TableCell>
        <TableCell sx={cell} align="center">{(term?.maxMark * 34) / 100 ?? 34}</TableCell>
        <TableCell sx={cell} align="center">{term?.marksObtained ?? "-"}</TableCell>
        <TableCell sx={cell} align="center">{term?.grade ?? "-"}</TableCell>
      </>
    );

  const MarksRowNon = (term) =>
    term?.remark === "non" && (
      <>
        <TableCell sx={cell} align="center">{term?.maxMark ?? 100}</TableCell>
        <TableCell sx={cell} align="center">{(term?.maxMark * 34) / 100 ?? 34}</TableCell>
        <TableCell sx={cell} align="center">{term?.marksObtained ?? "-"}</TableCell>
        <TableCell sx={cell} align="center">{term?.grade ?? "-"}</TableCell>
      </>
    );

  const studentInfo = () => {
    const data = student.find((m) =>  
      m.examType?.toLowerCase().includes('first'));
    return (
      <Box sx={{ lineHeight: 2 }} //width={'40%'}
      >
        <ProfileLine label="Name of the student" value={toCamelCase(`${data?.name} ${data?.last}`)} />
        <ProfileLine label="Father’s name" value={toCamelCase(`${data?.father}  ${data?.last}`)} />
        <ProfileLine label="Mother’s name" value={toCamelCase(`${data?.mother}  ${data?.last}`)} />
        <ProfileLine
          label="Studied"
          value={`${data?.classRoom?.standard} | Roll No : ${data?.classRoom?.rollNumber || ""}`}
        />
        <ProfileLine
          label="Admission No."
          value={`${data?.id || ""}  |  Caste: ${data?.caste || ""}`}
        />
        <ProfileLine
          label="Date of Birth"
          value={new Date(data?.birthday).toLocaleDateString("en-GB")}
        />

        <Typography variant="body2"><strong>{"(In words) : "}</strong> {convertDateToWords(data?.birthday)}
        </Typography>
        <Box display={'flex'} justifyContent={'space-between'}>
          <Typography variant="body2" fontWeight={700}>{"Hight/Weight"}</Typography>
          <TextField
            variant="standard"
            placeholder="..............."
            slotProps={{
              input: {
                disableUnderline: true,

              },
            }}
          />
        </Box>
      </Box>
    )
  };

  function ProfileLine({ label, value }) {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "220px auto",  // FIXED SPACE like screenshot
          mb: 0.5,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>{label} :</Typography>
        <Typography>{value}</Typography>
      </Box>
    );
  }

  return (
    <Box display={'flex'} flexDirection={'column'} id={receiptId}>
      <Box sx={{ p: 0, background: "#fff", fontFamily: "Arial", width: '100%' }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 0 }}>
          <Typography variant="subtitle1" align="center" fontWeight="bold">
            PROGRESS REPORT SESSION - {student[0]?.academicYear}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Student Info */}
        <Box sx={{ display: "flex", justifyContent: "space-around", mb: 2 }}>
          <Typography><strong>Student's Name: </strong> {toCamelCase(`${student[0]?.studentName}`)}</Typography>
          <Typography><strong>Standard: </strong>{student[0]?.classRoom.standard} | {student[0]?.classRoom.section}</Typography>
          <Typography><strong>Roll No.: </strong> {student[0]?.classRoom.id}</Typography>
        </Box>

        {/* Marks Table */}
        <Box sx={{ p: 0, mb: 1 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={cell} rowSpan={2} align="center">
                  <strong>Subject</strong>
                </TableCell>
                <TableCell sx={cell} colSpan={4} align="center">
                  <TextField
                    sx={{
                      mt: -0.5,
                      mb: -1,
                      "& .MuiInputBase-input": {
                        // fontSize: "0.900rem", 
                        fontWeight: 700
                      },
                    }}
                    variant="standard"
                    placeholder="Term-I"
                    slotProps={{
                      input: {
                        disableUnderline: true,
                      },
                    }}
                  />

                </TableCell>
                <TableCell sx={cell} colSpan={4} align="center">
                  <TextField
                    sx={{
                      mt: -0.5,
                      mb: -1,
                      "& .MuiInputBase-input": {
                        // fontSize: "0.900rem", 
                        fontWeight: 700
                      },
                    }}
                    variant="standard"
                    placeholder="Term-II"
                    slotProps={{
                      input: {
                        disableUnderline: true,
                      },
                    }}
                  />
                </TableCell>
                <TableCell sx={cell} colSpan={4} align="center">
                  <TextField
                    sx={{
                      mt: -0.5,
                      mb: -1,
                      "& .MuiInputBase-input": {
                        // fontSize: "0.900rem", 
                        fontWeight: 700
                      },
                    }}
                    variant="standard"
                    placeholder="Final-Exam"
                    slotProps={{
                      input: {
                        disableUnderline: true,
                      },
                    }}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                {[...Array(3)].flatMap(() => [
                  <TableCell sx={cell} align="center">Max</TableCell>,
                  <TableCell sx={cell} align="center">Min</TableCell>,
                  <TableCell sx={cell} align="center">Obt</TableCell>,
                  <TableCell sx={cell} align="center">Grade</TableCell>,
                ])}
              </TableRow>
            </TableHead>

            <TableBody>
              {subjects.map((sub, i) => {
                const term1 = findMark("First", sub.subjectName);
                const term2 = findMark("second", sub.subjectName);
                const finalExam = findMark("Final", sub.subjectName);
                return (
                  <TableRow key={i}>
                    {sub.remark !== 'non' && (
                      <TableCell sx={cell}>
                        {toCamelCase(sub.subjectName)}
                      </TableCell>
                    )}
                    {MarksRow(term1)}
                    {MarksRow(term2)}
                    {MarksRow(finalExam)}
                  </TableRow>
                );
              })}

              {/* Totals Row */}
              <TableRow sx={{ background: "#fff" }}>
                <TableCell sx={cell}><strong>Total Mark</strong></TableCell>

                {/* Term-I */}
                <TableCell sx={cell} align="center">{t1.max}</TableCell>
                <TableCell sx={cell} />
                <TableCell sx={cell} align="center">{t1.obt}</TableCell>
                <TableCell sx={cell} align="center">{t1.grade}</TableCell>

                {/* Term-II */}
                <TableCell sx={cell} align="center">{t2.max}</TableCell>
                <TableCell sx={cell} />
                <TableCell sx={cell} align="center">{t2.obt}</TableCell>
                <TableCell sx={cell} align="center">{t2.grade}</TableCell>

                {/* Final Exam */}
                <TableCell sx={cell} align="center">{t3.max}</TableCell>
                <TableCell sx={cell} />
                <TableCell sx={cell} align="center">{t3.obt}</TableCell>
                <TableCell sx={cell} align="center">{t3.grade}</TableCell>

              </TableRow>
            </TableBody>
          </Table>
        </Box>

        <Typography variant="subtitle1" align="center" fontWeight="bold">
          {"NON ACADEMIC PERFORMANCE"}</Typography>


        <Box sx={{ p: 0, mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={cell} rowSpan={2} align="center">
                  <strong>Subject</strong>
                </TableCell>

                <TableCell sx={cell} colSpan={4} align="center">
                  <TextField
                    sx={{
                      mt: -0.5,
                      mb: -1,
                      "& .MuiInputBase-input": {
                        // fontSize: "0.900rem", 
                        fontWeight: 700
                      },
                    }}
                    variant="standard"
                    placeholder="Term-I"
                    slotProps={{
                      input: {
                        disableUnderline: true,
                      },
                    }}
                  />
                </TableCell>
                <TableCell sx={cell} colSpan={4} align="center">
                  <TextField
                    sx={{
                      mt: -0.5,
                      mb: -1,
                      "& .MuiInputBase-input": {
                        // fontSize: "0.900rem", 
                        fontWeight: 700
                      },
                    }}
                    variant="standard"
                    placeholder="Term-II"
                    slotProps={{
                      input: {
                        disableUnderline: true,
                      },
                    }}
                  />
                </TableCell>
                <TableCell sx={cell} colSpan={4} align="center">
                  <TextField
                    sx={{
                      mt: -0.5,
                      mb: -1,
                      "& .MuiInputBase-input": {
                        // fontSize: "0.900rem", 
                        fontWeight: 700
                      },
                    }}
                    variant="standard"
                    placeholder="Final Exam"
                    slotProps={{
                      input: {
                        disableUnderline: true,
                      },
                    }}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                {[...Array(3)].flatMap(() => [
                  <TableCell sx={cell} align="center">Max</TableCell>,
                  <TableCell sx={cell} align="center">Min</TableCell>,
                  <TableCell sx={cell} align="center">Obt</TableCell>,
                  <TableCell sx={cell} align="center">Grade</TableCell>,
                ])}
              </TableRow>
            </TableHead>

            <TableBody>
              {subjects.map((sub, i) => {
                const term1 = findMark("First", sub.subjectName);
                const term2 = findMark("Second", sub.subjectName);
                const finalExam = findMark("Final", sub.subjectName);
                return (
                  <TableRow key={i}>
                    {sub.remark?.trim().toLowerCase() === 'non' && (
                      <TableCell sx={cell}>
                        {toCamelCase(sub.subjectName)}
                      </TableCell>
                    )}
                    {MarksRowNon(term1)}
                    {MarksRowNon(term2)}
                    {MarksRowNon(finalExam)}
                  </TableRow>
                );
              })}

              {/* Totals Row */}
              <TableRow sx={{ background: "#fff" }}>
                <TableCell sx={cell}><strong>Total Mark</strong></TableCell>

                {/* Term-I */}
                <TableCell sx={cell} align="center">{t4.max}</TableCell>
                <TableCell sx={cell} />
                <TableCell sx={cell} align="center">{t4.obt}</TableCell>
                <TableCell sx={cell} align="center">{t4.grade}</TableCell>

                {/* Term-II */}
                <TableCell sx={cell} align="center">{t5.max}</TableCell>
                <TableCell sx={cell} />
                <TableCell sx={cell} align="center">{t5.obt}</TableCell>
                <TableCell sx={cell} align="center">{t5.grade}</TableCell>

                {/* Final Exam */}
                <TableCell sx={cell} align="center">{t6.max}</TableCell>
                <TableCell sx={cell} />
                <TableCell sx={cell} align="center">{t6.obt}</TableCell>
                <TableCell sx={cell} align="center">{t6.grade}</TableCell>

              </TableRow>
            </TableBody>
          </Table>
        </Box>
        {/* Result Section */}
        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "space-around", mb: 2 }}>
          <Typography variant="subtitle1"><strong>Attendance Sem I & II - </strong>
            <TextField
              sx={{
                mt: 0,
                width: '25%',
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem",
                },
              }}
              variant="standard"
              placeholder="................."
              slotProps={{
                input: {
                  disableUnderline: true,
                },
              }}
            />
          </Typography>
          <Typography variant="subtitle1"><strong>Promoted to Class </strong>
            <TextField
              sx={{
                mt: 0,
                width: '25%',
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem",
                },
              }}
              variant="standard"
              placeholder={student[0]?.classRoom.standard}
              slotProps={{
                input: {
                  disableUnderline: true,
                },
              }}
            />
          </Typography>
          <Typography variant="subtitle1"><strong>Division : </strong>
            <TextField
              sx={{
                mt: 0,
                width: '25%',
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem",
                },
              }}
              variant="standard"
              placeholder={student[2]?.result}
              slotProps={{
                input: {
                  disableUnderline: true,
                },
              }}
            />
          </Typography>
          <Typography variant="body2"><strong>Percentage:</strong> {student[2]?.percentage}%</Typography>
        </Box>
        {/* Footer */}
        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "space-around", mb: 2 }}>
          <Typography variant="subtitle1">Class Teacher Sign </Typography>
          <Typography variant="subtitle1">Head Master: </Typography>
        </Box>
      </Box>


      <Divider className="pagebreak" />

      <Box sx={{
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        marginTop: 2
      }}>
        <Box sx={{ p: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 0 }}>
            <img
              src={school.logoUrl} // replace with your logo path
              alt="School Logo"
              style={{ width: 80, height: 70, marginTop: 10 }}
            />

            <Typography variant="h6" align="center" fontWeight="bold">
              {toCamelCase(school.schoolName)}
            </Typography>
            <Typography variant="subtitle2" align="center">
              {toCamelCase([school?.addressDTO?.addressLine1, school?.addressDTO?.city, school?.addressDTO?.pincode, school?.addressDTO?.state].join(", "))}
            </Typography>
            <Typography variant="subtitle1" align="center" fontWeight="bold">
              PROGRESS REPORT SESSION - {student[0]?.academicYear}
            </Typography>
            <img
              src={student[0]?.photo}
              alt={student[0]?.photo}
              style={{ width: 100, height: 100, marginTop: 10 }}
            />
          </Box>
          <Typography variant="subtitle1" align="center" fontWeight="bold">
            {"STUDENT PROFILE"}
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {/* Student Info */}
          <Box sx={{ display: "flex", justifyContent: "space-around", flexDirection: 'column', alignItems: 'center' }}>
            {studentInfo()}
            {/* <Box display={'flex'} justifyContent={'space-between'}>
              <Typography variant="subtitle1" fontWeight={700}>{"Hight/Weight"}</Typography>
              <TextField
                variant="standard"
                placeholder="..............."
                slotProps={{
                  input: {
                    disableUnderline: true,
                  },
                }}
              />
            </Box> */}
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Activity Table */}
        <Box sx={{ width: '50%', mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={cell1} colSpan={activities.length + 1} align="center">
                  <strong>Co-Curricular Activity</strong>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cell1} align="center">{'#'}</TableCell>
                {activities.map((a, i) => (
                  <TableCell sx={cell1} key={i} align="center">
                    {a.name}
                  </TableCell>
                ))}

              </TableRow>
            </TableHead>

            <TableBody>
              {totalActivity.map((sub, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell sx={cell1}>{toCamelCase(sub.name)}</TableCell>
                    {activities.map((_, j) => (
                      <TableCell sx={cell1} align="center" key={j}>
                        <TextField
                          variant="standard"
                          placeholder="Very Good"
                          slotProps={{
                            input: {
                              disableUnderline: true,
                            },
                          }}
                          sx={{
                            "& input": {
                              fontFamily: "inherit",
                              fontSize: "13px",
                            },
                          }}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={cell1} colSpan={totalGrade.length + 1} align="center">
                  <strong>Total Grade</strong>
                </TableCell>
              </TableRow>

              <TableRow>
                {totalGrade.map((a, j) => (
                  <TableCell sx={cell1} key={j} align="center">
                    {a.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {subjects.map((sub, i) => {
                return (
                  <TableRow key={i}>
                    {i < 3 && totalGrade.map((_, j) => (
                      <TableCell
                        key={j}
                        sx={cell1}
                      //align="center"
                      >
                        {j === 0 ? (
                          terms[i]?.n || "-"
                        ) : (
                          <TextField
                            variant="standard"
                            placeholder=".........."
                            slotProps={{ input: { disableUnderline: true, }, }}
                          />
                        )}
                      </TableCell>
                    ))}

                  </TableRow>
                );
              })}
            </TableBody>
          </Table>


          <TextField
            sx={{
              mt: 1,
              "& .MuiInputBase-input": {
                fontSize: "0.875rem", // as body2
              },
            }}
            variant="standard"
            placeholder="Very Good"
            slotProps={{
              input: { disableUnderline: true },
            }}
          />

          <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "space-around", my: 2 }}>
            <Typography variant="body2">Class Teacher sign </Typography>
            <Typography variant="body2">Head Master </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}